import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const headerDisplayName = 'CP';

const containerProviderDefinition: GridColDefExtended<DispatchLeg> = {
  field: 'Container Provider',
  minWidth: 75,
  width: 90,
  headerName: 'Container Provider',
  headerDisplayName,
  renderHeader: () => (
    <RenderHeader
      primaryText={headerDisplayName}
      title='Container Provider'
    />
  ),
  renderCell: ({ row }) => (
    <RenderCell
      primarySlot={
        row.cntrProviderName && (
          <span
            className={styles.bold}
            title={row.cntrProviderName}>
            {row.cntrProviderName}
          </span>
        )
      }
    />
  ),
  disableReorder: true,
  getApplyQuickFilterFn: (value: string) => {
    return (_, row): boolean =>
      applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
        const { cntrProviderName } = row;
        return caseInsensitiveIncludes(value, cntrProviderName);
      });
  },
  valueGetter: (_, row: DispatchLeg) => row.cntrProviderName ?? '',
  sortable: true,
  sortComparator: defaultSortComparator
};

export default containerProviderDefinition;
